import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { finalize, shareReplay, takeUntil, tap } from 'rxjs/operators';

import {
  CalenderEventCategories,
  GetCalenderByMonthAndYearDto,
} from 'src/app/core/api/models';
import { CalendersService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { FormPageConfig } from '../../../core/models/form-page-config.model';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { AppCalendarEvent } from './app-calendar-event.type';
import { CalendarEventsService } from './calendar-events.service';
import { CalendarFormComponent } from './calendar-form/calendar-form.component';
import { EventDetailComponent } from './event-detail/event-detail.component';

@Component({
    selector: 'app-calendar-events',
    templateUrl: './calendar-event.component.html',
    standalone: false
})

export class CalendarEventComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties
  calendarEventsService = inject(CalendarEventsService);

  pageName = 'calendarEvent';
  isCheckBoxChecked: boolean = true;
  isCalenderLoading: boolean = false;
  deleteEventMode: string = '';
  enumName: string = 'CalenderEventCategories';

  @Input('isSmallSizePage') input_isSmallSizePage: boolean = false;
  @Input('isModalMode') input_isModalMode: boolean;
  @Input('eventType') input_eventType: AppCalendarEvent;

  formPageConfig: FormPageConfig<GetCalenderByMonthAndYearDto> = {};
  selectedDayInfo: GetCalenderByMonthAndYearDto = {};
  items: Array<GetCalenderByMonthAndYearDto>;
  calenderEventCategories: Array<any>;
  temporarySelections: { [categoryId: string]: boolean } = {}; //Temporary variable to store temporary selection states
  userOrganizationId: number;
  year: number;
  month: number;
  form: FormGroup;
  isGetCalender: boolean = false;
  selectedCategories: number[] = [
    CalenderEventCategories.Ancient,
    CalenderEventCategories.Astronomical,
    CalenderEventCategories.International,
    CalenderEventCategories.National,
    CalenderEventCategories.Other,
    CalenderEventCategories.Religious,
  ];
  get CalenderEventCategories() {
    return CalenderEventCategories;
  }

  @Output('selectedCalendar') output_selectedCalendar =
    new EventEmitter<number>();
  @Output('selectedCalendarEvent') output_selectedCalendarEvent =
    new EventEmitter<number>();
  @Output('selectedCalenderOrganizationEvents')
  output_selectedCalenderOrganizationEvents = new EventEmitter<any>();
  //#endregion

  constructor(protected currentService: CalendersService) {
    super();
  }

  //#region init methods
  ngOnInit() {
    try {
      super.ngOnInit();
      this.calendarEventsService.selectedCategories.set([]);
      this.calendarEventsService.selectedCategories.set(
        this.selectedCategories
      );

      this.pageConfig.showAddBtn = false;
      this.pageConfig.showAuditBtn = false;
      this.pageConfig.isShowTable = false;
      if (this.input_isModalMode) this.pageConfig.showHeader = false;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }

    this.getItems();
  }

  // getEnumsValues() {
  //   this.getEnumValuesApi('CalenderEventCategories')
  //   .pipe(takeUntil(this.onDestroy$))
  //   .subscribe((values) => (this.calenderEventCategories = values));
  // }

  getTableData() {}

  configTableColumns() {}
  //#endregion

  //#region Api

  //Get All
  getPaginationApi() {
    return null;
  }

  //Delete
  baseDeleteApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;
    if (this.deleteEventMode == 'calendarEvent') {
      this.currentService
        .calendersDeleteCalenderEvent({ body: { id: id } })
        .pipe(this.basePipeOperators())
        .subscribe(
          (result) => {
            this.apiNotificationService.notifyMessage({ result });
            if (result.isSucceed) this.isGetCalender = true;
          },
          (error) => ConsoleService.error('error', error),
          () => (this.pageConfig.loading = false)
        );
    } else {
      this.currentService
        .calendersDeleteCalenderOrganizationEventCommand({ body: { id: id } })
        .pipe(this.basePipeOperators())
        .subscribe(
          (result) => {
            this.apiNotificationService.notifyMessage({ result });
            if (result.isSucceed) this.isGetCalender = true;
          },
          (error) => ConsoleService.error('error', error),
          () => (this.pageConfig.loading = false)
        );
    }
  }

  onCreate(event?: any, isFormModal?: boolean) {
    try {
      this.pageService = this.currentService;
      if (event.type == 'calendarOrganizationEvent')
        this.createGetApiMethodName =
          'calendersCreateCalenderOrganizationEventGet';
      else if (event.type == 'calendarEvent')
        this.createGetApiMethodName = 'calendersCreateCalenderEventGet';

      this.pageService[this.createGetApiMethodName]()
        .pipe(this.basePipeOperators())
        .subscribe(
          (res) => {
            if (res) {
              if (isFormModal) {
                const timeout = setTimeout(() => {
                  clearTimeout(timeout);
                }, 10);
                this.onCreateCalendarEventModal(event);
              }
            }
          },
          (error) => {
            this.pageConfig.isVisibleForm = undefined;
            const timeout = setTimeout(() => {
              this.pageConfig.isVisibleForm = false;
              clearTimeout(timeout);
            }, 10);
          }
        );
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  //#endregion

  //#region modals

  //create modal
  onCreateCalendarEventModal(event) {
    try {
      this.unSubs();
      let data = {
        isEdit: false,
        title: `${this.formPageConfig?.vocabs}addTitle`,
        calendarId: event.id,
        calenderEventType: event.type,
        isHoliday: event.isHoliday,
      };

      const modalResult = this.dialogService.openModal({
        component: CalendarFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.isGetCalender = true;
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  //edit modal
  onEditCalendarEventModal(selectedDayInfo) {
    try {
      this.unSubs();

      let data = {
        title: `${this.formPageConfig?.vocabs}editTitle`,
        model: selectedDayInfo.event,
        isEdit: true,
        calenderEventType: selectedDayInfo.type,
        isHoliday: selectedDayInfo.event?.isHoliday,
      };

      const modalResult = this.dialogService.openModal({
        component: CalendarFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.isGetCalender = true;
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  //show info modal
  openSelectedEventInfo(event) {
    try {
      this.unSubs();
      let data = {
        isEdit: false,
        title: `${this.formPageConfig?.vocabs}detailTitle`,
        event: event,
        selectedDayInfo: this.selectedDayInfo,
      };

      const modalResult = this.dialogService.openModal({
        component: EventDetailComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.isGetCalender = true;
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }
  //#endregion

  // change event category
  changeEventCategory(categories) {
    try {
      this.temporarySelections[categories.id] =
        !this.temporarySelections[categories.id];

      if (!this.temporarySelections[categories.id])
        this.selectedCategories = this.selectedCategories.filter(
          (item) => item !== categories.id
        );
      else this.selectedCategories.push(categories.id);
      this.calendarEventsService.selectedCategories.set([]);
      this.calendarEventsService.selectedCategories.set(
        this.selectedCategories
      );
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  onSelect(body) {
    this.output_selectedCalendar.emit(body);
  }

  onSelectCalendarEvent(event) {
    this.output_selectedCalendarEvent.emit(event);
  }

  onSelectCalenderOrganizationEvents(event) {
    this.output_selectedCalenderOrganizationEvents.emit(event);
  }

  // in this method get Calender Event Categories enum
  //TODO Calender Event Categories enum
  getItems() {
    if (this.loading) return;
    this.loading = true;

    this.enumService
      .enumsGetEnumValues({ EnumTypeName: this.enumName })
      .pipe(this.baseSelectionSearchPipeOperators)
      .subscribe((items) => {
        this.calenderEventCategories = items?.data?.map((item) => {
          return { name: item.value, id: item.key };
        });

        for (const category of this.calenderEventCategories) {
          this.temporarySelections[category.id] = true;
        }
      });
  }

  baseSelectionSearchPipeOperators = (
    source$: Observable<any>
  ): Observable<any> => {
    return source$.pipe(
      shareReplay(),
      takeUntil(this.onDestroy$),
      finalize(() => {
        this.loading = false;
      })
    );
  };

  calenderLoading(event) {
    this.isCalenderLoading = event;
  }
  
}
